module.exports = __webpack_public_path__ + "static/media/Cersei Lannister 1.46a59d3b.jpg";